import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/user/live")({
  staticData: { application: "Pricing" },
});
